import {ErrorHandler} from '@angular/core';
import {Injectable} from '@angular/core';
import {FNErrorLogSvcs} from './fn-error.log.svcs';

// export interface LoggingErrorHandlerOptions {
//   rethrowError: boolean;
//   unwrapError: boolean;
// }

// // tslint:disable-next-line: variable-name
// export let LOGGING_ERROR_HANDLER_OPTIONS: LoggingErrorHandlerOptions = {rethrowError: false, unwrapError: false};


/**
 * service to handle Error 
 */
@Injectable()
export class FNErrorHandler implements ErrorHandler {

  /**
   * protected variable to store FNErrorLogSvcs refrence.
   */
  protected errorLogService: FNErrorLogSvcs;

  // private options: LoggingErrorHandlerOptions;

  /**
   * Creates an instance of fnerror handler.
   * @param errorLogService FNErrorLogSvcs object to logError on console
   */
  constructor(errorLogService: FNErrorLogSvcs) {
    this.errorLogService = errorLogService;
  }

  /**
   * Method to handle the given error.
   * @param error 
   */
  public handleError(error: any): void {
    // Log to the console. or Send to the error-logging service.
    try {
      this.errorLogService.logError(error);

    } catch (handlingError) {
      console.group('ErrorHandler');
      console.warn('Error when trying to output error.');
      console.error(handlingError);
      console.groupEnd();

    }

  }

}


// I am the collection of providers used for this service at the module level.
// Notice that we are overriding the CORE ErrorHandler with our own class definition.
// --
// CAUTION: These are at the BOTTOM of the file so that we don't have to worry about
// creating futureRef() and hoisting behavior.
// export let LOGGING_ERROR_HANDLER_PROVIDERS = [
// 	// {
// 	// 	provide: LOGGING_ERROR_HANDLER_OPTIONS,
// 	// 	useValue: LOGGING_ERROR_HANDLER_OPTIONS
// 	// },
// 	{
// 		provide: ErrorHandler,
// 		useClass: FNErrorHandler
// 	}
// ];

